export class CustomersRepository {
  private _remote_procedure_call: string = "rooftop_unique_customers_admin_6";
  public supabaseClient: any;
  public _rooftopId: string;

  constructor(supabaseClient: any, rooftopId: string | null) {
    this.supabaseClient = supabaseClient;
    this._rooftopId = rooftopId ?? "";
  }

  // Fetch a single customer with basic info
  async getCustomerBasic(id: number) {
    return await this.supabaseClient
      .from("customer_data")
      .select(
        "id, first_name, last_name, phone, email, rooftop_id, engaged, opt_in, last_viewed_at, last_viewed_by, mileage, appt_date, appt_time"
      )
      .eq("id", id)
      .single();
  }

  // Fetch all customers (customize as needed)
  async getAllCustomers() {
    const { data, error } = await this.supabaseClient
      .from("customer_data")
      .select("*")
      .eq("rooftop_id", this._rooftopId);

    return { data, error };
  }

  async getAllCustomers_WithLoanBalance_WithCreditInfo() {
    const { data, error } = await this.supabaseClient
      .from("customer_data")
      .select(
        `
        *, 
        credit_info (credit_score, credit_freeze, credit_error, no_hit), 
        loan_info (loan_balance, payment)`
      )
      .eq("rooftop_id", this._rooftopId);

    return { data, error };
  }

  async getAllCustomers_WithLoanBalance_WithCreditInfo_WithVehicle() {
    const { data, error } = await this.supabaseClient
      .from("customer_data")
      .select(
        `
        *, 
        engaged_by:notifications (
          user:user_id (
            username
          )
        ),
        credit_info (credit_score, credit_freeze, credit_error, no_hit), 
        loan_info (loan_balance, payment),
        vehicles (id, year, make, model)
        `
      )
      .eq("rooftop_id", this._rooftopId);

    return { data, error };
  }

  async getTodaysAction_ByDate(date: string) {
    //const dateStr = date || new Date().toISOString().split("T")[0];
    const { data, error } = await this.supabaseClient
      .from("customer_data")
      .select(
        `
        *, 
        engaged_by:notifications (
          user:user_id (
            username
          )
        ),
        credit_info (credit_score, credit_freeze, credit_error, no_hit), 
        loan_info (loan_balance, payment),
        vehicles (id, year, make, model)
        `
      )
      .eq("rooftop_id", this._rooftopId)
      .eq("appt_date", date);

    return { data, error };
  }

  async getDealerVaultNumber(customerId: number): Promise<{
    DV_customer_number: string;
    vin: string;
    first_name: string;
    last_name: string;
  } | null> {
    const { data, error } = await this.supabaseClient
      .from("customer_data")
      .select("DV_customer_number, vin, first_name, last_name")
      .eq("id", customerId)
      //.eq('rooftop_id', this._rooftopId)
      .single();

    if (error) {
      console.error("❌ Error fetching customer data:", error);
    }

    if (data) {
      return {
        DV_customer_number: data.DV_customer_number,
        vin: data.vin,
        first_name: data.first_name,
        last_name: data.last_name,
      };
    }
    return null;
  }

  // Fetch related data for a customer
  static async getCreditInfo(customerId: number) {
    let supabase = useSupabaseClient();
    return supabase
      .from("credit_info")
      .select("*")
      .eq("customer_id", customerId)
      .order("created_at", { ascending: false });
  }

  static async getLoanInfo(customerId: number) {
    let supabase = useSupabaseClient();
    return supabase
      .from("loan_info")
      .select("*")
      .eq("customer_id", customerId)
      .order("created_at", { ascending: false });
  }

  static async getValuations(customerId: number) {
    let supabase = useSupabaseClient();
    return supabase
      .from("valuations")
      .select("*")
      .eq("customer_id", customerId);
  }

  static async getVehicle(customerId: number) {
    let supabase = useSupabaseClient();
    return supabase.from("vehicles").select("*").eq("customer_id", customerId);
  }

  static async getCustomerNotes(customerId: number) {
    let supabase = useSupabaseClient();
    return supabase
      .from("customer_notes")
      .select("*")
      .eq("customer_id", customerId)
      .order("created_at", { ascending: false });
  }

  // Update last viewed info
  static async updateLastViewed(customerId: number, userId: string) {
    // let supabase = useSupabaseClient();
    // return supabase
    //   .from('customer_data')
    //   .update({
    //     last_viewed_at: new Date().toISOString(),
    //     last_viewed_by: userId
    //   })
    //   .eq('id', customerId);
  }

  // Update engaged status
  static async updateEngagedStatus(customerId: number, engaged: boolean) {
    // let supabase = useSupabaseClient();
    // return supabase
    //   .from('customer_data')
    //   .update({ engaged, checked_in: engaged })
    //   .eq('id', customerId);
  }

  // Insert, update, delete customer (for real-time events)
  static async getCustomerWithRelations(id: string | number) {
    let supabase = useSupabaseClient();
    return supabase
      .from("customer_data")
      .select(
        `
        *,
        vehicles (id, year, make, model, trim),
        valuations (low, target, high),
        credit_info (credit_score, credit_freeze, credit_error, no_hit, created_at),
        loan_info (loan_balance, payment, created_at, acct_type, primary),
        customer_notes (id, content, created_at),
        equity_scores (id, score, created_at)
      `
      )
      .eq("id", id)
      .single();
  }

async getSuperAdminCustomers() {
  try {
    const { data, error } = await this.supabaseClient.rpc(
      this._remote_procedure_call,
      { r_rooftop: "DVD00001" }
    );

    if (error) {
      throw new Error(`Count RPC failed: ${error.message}`);
    }

    // FIX: Return the data and error as expected by the loader
return { data: data ?? [], error: null }
  } catch (err: any) {
    console.error("Error fetching customers:", err.message);
    return {
      data: null,
      error: {
        message: "Failed to fetch customers",
        details: err.message,
      },
    };
  }
}
}
